import $ from 'jquery';

const filterSelector = '[data-content-category-filter]';
const topicSelector = '[data-content-category-topic]';
const resultsSelector = '[data-content-category-results]';

let currentRequest = null;

const getAjaxData = () => window.CONTENT_CATEGORY_FILTER_DATA || null;

const getTopicFromUrl = () => {
  const params = new URLSearchParams(window.location.search);

  return params.get('topic') || '';
};

const setActiveTopic = ($filter, topic) => {
  $filter.find(topicSelector).each((index, element) => {
    const $link = $(element);
    const isActive = ($link.data('contentCategoryTopic') || '') === topic;

    $link.toggleClass('is-active', isActive);

    if (isActive) {
      $link.attr('aria-current', 'page');
    } else {
      $link.removeAttr('aria-current');
    }
  });
};

const loadCategory = ($filter, $link, pushState = true) => {
  const contentType = $filter.data('contentType');
  const topic = $link.data('contentCategoryTopic') || '';
  const targetUrl = $link.attr('href');
  const $results = $(`${resultsSelector}[data-content-type="${contentType}"]`);

  const ajaxData = getAjaxData();

  if (!contentType || !targetUrl || !$results.length || !ajaxData) {
    window.location.href = targetUrl;
    return;
  }

  if (currentRequest) {
    currentRequest.abort();
  }

  setActiveTopic($filter, topic);
  $results.addClass('is-loading').attr('aria-busy', 'true');

  if (pushState && window.history && window.history.pushState) {
    window.history.pushState({ contentType, topic }, '', targetUrl);
  }

  const request = $.ajax({
    method: 'POST',
    url: ajaxData.ajaxUrl,
    data: {
      action: 'content_category_filter',
      nonce: ajaxData.nonce,
      contentType,
      topic
    }
  });

  currentRequest = request;

  request
    .done((response) => {
      if (response && response.success && response.data && response.data.html) {
        $results.html(response.data.html);
      } else {
        window.location.href = targetUrl;
      }
    })
    .fail((xhr, status) => {
      if (status !== 'abort') {
        window.location.href = targetUrl;
      }
    })
    .always(() => {
      if (currentRequest !== request) {
        return;
      }

      $results.removeClass('is-loading').removeAttr('aria-busy');
      currentRequest = null;
    });
};

$(document).on('click', `${filterSelector} ${topicSelector}`, (event) => {
  const $link = $(event.currentTarget);
  const $filter = $link.closest(filterSelector);

  if ($link.hasClass('is-active')) {
    event.preventDefault();
    return;
  }

  if (
    event.metaKey ||
    event.ctrlKey ||
    event.shiftKey ||
    event.altKey
  ) {
    return;
  }

  event.preventDefault();
  loadCategory($filter, $link);
});

$(window).on('popstate', () => {
  const $filter = $(filterSelector).first();

  if (!$filter.length) {
    return;
  }

  const topic = getTopicFromUrl();
  const $link = $filter
    .find(topicSelector)
    .filter((index, element) => ($(element).data('contentCategoryTopic') || '') === topic)
    .first();

  if ($link.length) {
    loadCategory($filter, $link, false);
  }
});
